<template>
  <span class="flex items-start gap-3">
    <i
      class="fas mt-0.5 w-5 shrink-0 text-center text-base"
      :class="[option.icon, option.color]"
    ></i>
    <span class="min-w-0">
      <span class="block text-sm font-medium text-gray-900">{{
        option.label
      }}</span>
      <span class="block text-xs text-gray-500">{{ option.description }}</span>
    </span>
  </span>
</template>

<script setup lang="ts">
import type { QuestionType } from "./customFormFields";

defineProps<{ option: QuestionType }>();
</script>
